// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1931":"06281429eeeea226","3185":"9de599fb64f76280","9848":"007623e45375df5f"}[chunkId] + ".css";
};